import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/content";
import { formatShortDate } from "@/utils/content";

interface NewsRowProps {
  item: NewsItem;
}

export function NewsRow({ item }: NewsRowProps) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col gap-3 border-b border-background-800 py-5 transition-colors last:border-b-0 sm:flex-row sm:items-start sm:gap-4"
    >
      <span className="h-32 w-full shrink-0 overflow-hidden rounded-md bg-background-800 sm:h-20 sm:w-32">
        <img
          src={item.thumbnail}
          alt={`${item.title}配图`}
          title={`${item.title} - 日本伦理行业资讯`}
          className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
        />
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex flex-wrap items-center gap-2 text-xs">
          <span className="rounded-full bg-secondary-800/60 px-2 py-0.5 text-[11px] text-secondary-100">
            {item.category}
          </span>
          <span className="font-label uppercase tracking-[0.14em] text-foreground-500">
            {formatShortDate(item.date)}
          </span>
        </span>
        <span className="mt-2 block text-base font-medium leading-snug text-foreground-950 transition-colors group-hover:text-accent-400">
          {item.title}
        </span>
        <span className="mt-1.5 line-clamp-2 block text-sm leading-relaxed text-foreground-600">
          {item.excerpt}
        </span>
      </span>
    </Link>
  );
}

export function NewsCard({ item }: NewsRowProps) {
  return (
    <Link to={`/news/${item.id}`} className="group block">
      <div className="aspect-[16/9] w-full overflow-hidden rounded-lg bg-background-800">
        <img
          src={item.thumbnail}
          alt={`${item.title}配图`}
          title={`${item.title} - 日本伦理行业资讯`}
          className="h-full w-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
        <span className="text-accent-500">{item.category}</span>
        <span className="h-3 w-px bg-background-700"></span>
        <span className="font-label tracking-[0.12em]">{formatShortDate(item.date)}</span>
      </div>
      <h3 className="mt-2 line-clamp-2 text-base font-medium leading-snug text-foreground-950 transition-colors group-hover:text-accent-400">
        {item.title}
      </h3>
    </Link>
  );
}